import styled from "styled-components";

const Subtitle = styled.h1`
  text-align: left;
  color: #393939;
  font-weight: bold;
  margin: 0 0 0 0;
`

export default Subtitle;